import { render, staticRenderFns } from "./JcdcFooter.vue?vue&type=template&id=33535a60"
import script from "./JcdcFooter.vue?vue&type=script&lang=ts"
export * from "./JcdcFooter.vue?vue&type=script&lang=ts"
import style0 from "./JcdcFooter.vue?vue&type=style&index=0&id=33535a60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports